import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import color from 'color'
import {theme} from '../../../../../../../../utils/theme'
const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      margin: theme.spacing(1),
      maxWidth: theme.spacing(48),
      height: theme.spacing(16),
      padding:theme.spacing(4),

    },
  },

}));

export default function SimplePaper({name,classs,test_date,roll_no}) {
  const classes = useStyles();

  return (


    <Card  style={{backgroundColor:color(theme.palette.primary.main).lighten(1.5),padding:20}}>

       <CardContent style={{padding:0}}>

       <Typography type="subheading">
       <b>Aptitude Test Roll No.</b> : {roll_no}
       </Typography> 
       <br/>
         <Typography type="subheading">
        <b>Name</b> : {name}
         </Typography>
     <br/>

     <Typography type="subtitle">
    <b> Moving Class</b> : {classs}
     </Typography>
     <br />
     <Typography type="subtitle">
     <b>Test Date</b> : {test_date}
     </Typography>
       </CardContent>


     </Card>

  );
}
